import React, { useEffect, useState } from "react";
import GoogleButton from "../Login/GoogleButton";
import AppleLogin from "../Login/AppleLogin";
import WebAppleLogin from "../Login/WebAppleLogin";

const SocialLogin = () => {
  const [isFlutterWebViewReady, setIsFlutterWebViewReady] = useState(false);
  const [deviceType, setDeviceType] = useState("Unknown");

  useEffect(() => {
    const userAgent = navigator.userAgent;

    let device_type = "Unknown";

    if (/Android/i.test(userAgent)) {
      device_type = "A"
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I"
    } else {
      device_type = "W"
    }

    setDeviceType(device_type);

    // Check if device type is iOS from local storage
    const flutterWebView = localStorage.getItem("isFlutterInAppWebViewReady");
    setIsFlutterWebViewReady(flutterWebView === "true");
  }, []); // Run once when component mounts


  return (
    <>
      <div className="flex justify-between w-full mt-2">
        {deviceType === "I" && isFlutterWebViewReady && <AppleLogin />} {/* Render AppleLogin component if device is iOS */}
      </div>

      <div className="flex justify-between w-full mt-2">
        {!isFlutterWebViewReady && <WebAppleLogin />} {/* Render WebAppleLogin component for Web */}
      </div>


      <div className="flex justify-between w-full mt-2">
        <GoogleButton />
      </div>

    </>
  );
};

export default SocialLogin;
